import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUPPORTER_GROWTH_PSF_SHARE_ASSETS_EXPERIMENT = createFcmDetails(
	'supporter_growth_psf_share_assets_experiment',
	{
		owner: 'Supporter Growth Squad',
		context: 'Post Sign Flow (PSF)',
		description:
			'Experiment to test displaying PSF share visual assets in OG tags for share links originating from PSF: https://change.atlassian.net/browse/CHANGE-80701 ',
		template: {
			experimentName: '',
		},
		import: false,
	},
);
